/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MailParamsTelematicCancellationTemplateData } from '../../models/mail-params-telematic-cancellation-template-data';
import { ResponseObject } from '../../models/response-object';

export interface SendTelematicCancellationMail$Params {
      body: MailParamsTelematicCancellationTemplateData
}

export function sendTelematicCancellationMail(http: HttpClient, rootUrl: string, params: SendTelematicCancellationMail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseObject>> {
  const rb = new RequestBuilder(rootUrl, sendTelematicCancellationMail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseObject>;
    })
  );
}

sendTelematicCancellationMail.PATH = '/sendMail/telematic-cancellation';
